import styled from 'styled-components';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const ButtonWrapper = styled.div.withConfig({
  displayName: "PostmanButton__ButtonWrapper",
  componentId: "wkg5xw-0"
})(["float:right;"]);
function PostmanButton(props) {
  const {
    collectionId
  } = props;
  return /*#__PURE__*/_jsx(ButtonWrapper, {
    children: /*#__PURE__*/_jsx(Button, {
      use: "tertiary",
      href: `https://app.getpostman.com/run-collection/${collectionId}`,
      external: true,
      children: "Run in Postman"
    })
  });
}
export default PostmanButton;